export const SALES_CONNECTION_PROVIDERS = ["SALESFORCE", "HUBSPOT"] as const;
export type SalesConnectionProvider =
  (typeof SALES_CONNECTION_PROVIDERS)[number];
export const BILLING_CONNECTION_PROVIDERS = ["STRIPE", "QONTO", "NETSUITE"] as const;
export type BillingConnectionProvider =
  (typeof BILLING_CONNECTION_PROVIDERS)[number];

export type ConnectionProvider =
  | SalesConnectionProvider
  | BillingConnectionProvider;

export type UserConnections = {
  salesConnectionProvider: SalesConnectionProvider | null;
  billingConnectionProvider: BillingConnectionProvider | null;
};

export const isSalesConnectionProvider = (
  connectionProvider: ConnectionProvider,
): boolean => {
  return (SALES_CONNECTION_PROVIDERS as readonly ConnectionProvider[]).includes(
    connectionProvider,
  );
};
